import React from 'react';
import classnames from 'classnames';
import { t, props } from 'tcomb-react';

@props({
  striped: t.Bool,
  columns: t.Arr,
  children: t.Any
})
export default class Table extends React.Component {

  render() {
    const className = {
      table: true,
      'table-striped': this.props.striped
    };
    return (
      <table className={classnames(className)}>
        <thead>
          <tr>
            {
              this.props.columns.map((column, i) => <th key={i}>{column}</th>)
            }
          </tr>
        </thead>
        <tbody>
          { this.props.children }
        </tbody>
      </table>
    );
 }

}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/Table.js
 **/